// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file description_support/v1/field_description.proto (package description_support.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { enumDesc, extDesc, fileDesc, tsEnum } = require("@bufbuild/protobuf/codegenv2");
const { file_google_protobuf_descriptor } = require("../../google/protobuf/descriptor_pb");

/**
 * Describes the file description_support/v1/field_description.proto.
 */
const file_description_support_v1_field_description = /*@__PURE__*/
  fileDesc("Ci5kZXNjcmlwdGlvbl9zdXBwb3J0L3YxL2ZpZWxkX2Rlc2NyaXB0aW9uLnByb3RvEhZkZXNjcmlwdGlvbl9zdXBwb3J0LnYxKm0KCU93bmVyVGVhbRIaChZPV05FUl9URUFNX1VOU1BFQ0lGSUVEEAASGAoUT1dORVJfVEVBTV9PVE9SSUhJS0kQARIUChBPV05FUl9URUFNX1RFTlBPEAISFAoQT1dORVJfVEVBTV9VUklCQRADOl8KHGZpZWxkX2Rlc2NyaXB0aW9uX2Zvcl9ub19zd2USHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGKKQAyABKAlSGGZpZWxkRGVzY3JpcHRpb25Gb3JOb1N3ZTpRChVmaWVsZF9oaWRlX2Zvcl9ub19zd2USHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGKOQAyABKAhSEWZpZWxkSGlkZUZvck5vU3dlOloKGWFsbG93X2Nhc3VhbF9jaGFuZ2VfdmFsdWUSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGKSQAyABKAhSFmFsbG93Q2FzdWFsQ2hhbmdlVmFsdWU6UQoVZmllbGRfbmFtZV9mb3Jfbm9fc3dlEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxilkAMgASgJUhFmaWVsZE5hbWVGb3JOb1N3ZTpTChVzZXR1cF9wcm9jZWR1cmVfbGlua3MSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGKaQAyADKAlSE3NldHVwUHJvY2VkdXJlTGlua3M6YQoKb3duZXJfdGVhbRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYp5ADIAEoDjIhLmRlc2NyaXB0aW9uX3N1cHBvcnQudjEuT3duZXJUZWFtUglvd25lclRlYW06VAoWZXhwb3NlX3RvX2N1c3RvbWVyX2FwcBIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYqJADIAEoCFITZXhwb3NlVG9DdXN0b21lckFwcDpYChhleHBvc2VfdG9fZXh0ZXJuYWxfYWRtaW4SHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGKmQAyABKAhSFWV4cG9zZVRvRXh0ZXJuYWxBZG1pbjprCiNvbmVfb2ZfZmllbGRfZGVzY3JpcHRpb25fZm9yX25vX3N3ZRIdLmdvb2dsZS5wcm90b2J1Zi5PbmVvZk9wdGlvbnMYtpADIAEoCVIdb25lT2ZGaWVsZERlc2NyaXB0aW9uRm9yTm9Td2U6XQocb25lX29mX2ZpZWxkX25hbWVfZm9yX25vX3N3ZRIdLmdvb2dsZS5wcm90b2J1Zi5PbmVvZk9wdGlvbnMYt5ADIAEoCVIWb25lT2ZGaWVsZE5hbWVGb3JOb1N3ZWIGcHJvdG8z", [file_google_protobuf_descriptor]);

/**
 * Describes the enum description_support.v1.OwnerTeam.
 */
const OwnerTeamSchema = /*@__PURE__*/
  enumDesc(file_description_support_v1_field_description, 0);

/**
 * フィールドのオーナーチームを表すenumです。
 *
 * @generated from enum description_support.v1.OwnerTeam
 */
const OwnerTeam = /*@__PURE__*/
  tsEnum(OwnerTeamSchema);

/**
 * NOTE: パートナーや10X内の非SWEでも理解できるようにフィールドに説明をつけるためのアノテーションです。
 *
 * @generated from extension: string field_description_for_no_swe = 51234;
 */
const field_description_for_no_swe = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 0);

/**
 * NOTE: フィールドを非SWEには指定出来ないようにするためのアノテーションです。
 *
 * 特定パートナーにのみ提供する機能に使います
 *
 * @generated from extension: bool field_hide_for_no_swe = 51235;
 */
const field_hide_for_no_swe = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 1);

/**
 * NOTE: フィールドがカジュアルに変更可能かを表します。
 *
 * 逆にこれが指定なしならカジュアルに変更できないです。
 *
 * @generated from extension: bool allow_casual_change_value = 51236;
 */
const allow_casual_change_value = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 2);

/**
 * NOTE: パートナーや10X内の非SWEでも理解できるようにフィールドにラベル(名前)をつけるためのアノテーションです。
 *
 * @generated from extension: string field_name_for_no_swe = 51237;
 */
const field_name_for_no_swe = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 3);

/**
 * NOTE: 設定後に必要な手順へのリンクを記述するためのアノテーションです。
 * 複数のリンクを指定できます。
 *
 * @generated from extension: repeated string setup_procedure_links = 51238;
 */
const setup_procedure_links = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 4);

/**
 * NOTE: フィールドのオーナーチームを指定するためのアノテーションです。
 *
 * @generated from extension: description_support.v1.OwnerTeam owner_team = 51239;
 */
const owner_team = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 5);

/**
 * NOTE: お客様アプリへのフィールド公開を指定するためのアノテーションです。
 *
 * 未指定の場合は、未公開として扱われます。
 *
 * @generated from extension: bool expose_to_customer_app = 51240;
 */
const expose_to_customer_app = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 6);

/**
 * NOTE: 外部管理画面へのフィールド公開を指定するためのアノテーションです。
 *
 * 未指定の場合は、未公開として扱われます。
 *
 * @generated from extension: bool expose_to_external_admin = 51241;
 */
const expose_to_external_admin = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 7);

/**
 * NOTE: パートナーや10X内の非SWEでも理解できるようにフィールドに説明をつけるためのアノテーションです。
 *
 * @generated from extension: string one_of_field_description_for_no_swe = 51254;
 */
const one_of_field_description_for_no_swe = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 8);

/**
 * NOTE: パートナーや10X内の非SWEでも理解できるようにフィールドにラベル(名前)をつけるためのアノテーションです。
 *
 * @generated from extension: string one_of_field_name_for_no_swe = 51255;
 */
const one_of_field_name_for_no_swe = /*@__PURE__*/
  extDesc(file_description_support_v1_field_description, 9);


exports.file_description_support_v1_field_description = file_description_support_v1_field_description;
exports.OwnerTeamSchema = OwnerTeamSchema;
exports.OwnerTeam = OwnerTeam;
exports.field_description_for_no_swe = field_description_for_no_swe;
exports.field_hide_for_no_swe = field_hide_for_no_swe;
exports.allow_casual_change_value = allow_casual_change_value;
exports.field_name_for_no_swe = field_name_for_no_swe;
exports.setup_procedure_links = setup_procedure_links;
exports.owner_team = owner_team;
exports.expose_to_customer_app = expose_to_customer_app;
exports.expose_to_external_admin = expose_to_external_admin;
exports.one_of_field_description_for_no_swe = one_of_field_description_for_no_swe;
exports.one_of_field_name_for_no_swe = one_of_field_name_for_no_swe;
